/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

/**
 * Calculate the total progress bar.
 */
@Component({
  selector: 'app-story-progress',
  templateUrl: './story-progress.component.html',
  styleUrls: ['./story-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoryProgressComponent implements OnInit {

  /**
   * Get the Stories.
   * Active index of the stories
   * Duration of the particular story.
   */
  @Input() stories: any[];
  @Input() activeIndex: number;
  @Input() duration: number;
  @Input() storyProgressPercentage: string;

  @Input() loadingState: boolean;
  /**
   * Get the total number of progress bar style according to the stories length.
   */
  public getTotalProgressBarStyles() {
    return {
      display: 'grid',
      'grid-template-columns': `repeat(${this.stories?.length}, 1fr)`,
      padding: '8px 10px'
    };
  }

  ngOnInit(): void {
  }

  /**
   * Track by function for the stories.
   */
  trackByFn(index: any, item: any): any {
    return index;
  }
}
